// extracted by mini-css-extract-plugin
module.exports = {"root":"PublicationItem_root__CkwJr","details":"PublicationItem_details__vhQDj","heading":"PublicationItem_heading__7Nqyz","image":"PublicationItem_image__vmwZS"};